import { useEffect, useRef } from "react";

// Stage pills of the tablet / phone board: one tap brings the column into view, the active one follows the scroll.
// A phone shows the current stage name in its pill and the count, so nothing has to be guessed from a half-hidden column.
export default function StageTabs({ stages, counts, activeId, onSelect }) {
  const strip = useRef(null);
  useEffect(() => {
    const el = strip.current?.querySelector('[aria-current="true"]');
    if (el && strip.current) strip.current.scrollTo({ left: Math.max(el.offsetLeft - 16, 0), behavior: "smooth" });
  }, [activeId]);
  return (
    <nav aria-label="Étapes du pipeline" className="-mx-4 md:-mx-6 px-4 md:px-6 overflow-x-auto scrollbar-thin" ref={strip} data-testid="stage-tabs">
      <ul className="flex w-max gap-2 pb-1">
        {stages.map((s) => {
          const active = s.id === activeId;
          return (
            <li key={s.id}>
              <button
                type="button"
                aria-current={active ? "true" : undefined}
                onClick={() => onSelect(s.id)}
                data-testid={`stage-tab-${s.id}`}
                className={`inline-flex h-11 items-center gap-2 rounded-full border px-4 text-sm font-medium transition focus-visible:outline focus-visible:outline-2 focus-visible:outline-jamora ${
                  active ? "border-jamora bg-jamora text-white" : "border-slate-200 bg-white text-slate-700 hover:border-jamora"
                }`}
              >
                {s.label}
                <span className={`font-mono text-xs ${active ? "text-white/90" : "text-slate-600"}`}>{counts[s.id] ?? "…"}</span>
              </button>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
